import { render, staticRenderFns } from "./deanSpinner.vue?vue&type=template&id=0baf9742&scoped=true"
import script from "./deanSpinner.vue?vue&type=script&lang=ts"
export * from "./deanSpinner.vue?vue&type=script&lang=ts"
import style0 from "./deanSpinner.vue?vue&type=style&index=0&id=0baf9742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf9742",
  null
  
)

export default component.exports